import { cloneDeep } from 'lodash';
import React, { useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
import { Input, Select } from '@panwds/react-ui';
import { isNilOrEmptyString } from '../../utils/utils.esm.js';
import { RangeFilterOptions } from './RangeFilterOptions.esm.js';

function RangeFilter(props) {
    var _a, _b;
    const { defaultValues } = props;
    const intl = useIntl();
    const itemsForSelect = useMemo(() => [
        { children: "B", value: "b" },
        { children: "KB", value: "kb" },
        { children: "MB", value: "mb" },
        { children: "GB", value: "gb" },
    ], []);
    const defaultOptions = {
        inputValue: "",
        selectedItemValue: itemsForSelect[0],
    };
    const defaultRangeValues = {
        greater_than: [{ ...defaultOptions }],
        less_than: [{ ...defaultOptions }],
        between: [{ ...defaultOptions }, cloneDeep({ ...defaultOptions })],
    };
    const [radioSelected, setRadioSelected] = useState(defaultValues || "");
    const [rangeValues, setRangeValues] = useState(defaultRangeValues);
    const updateRadioSelected = (radio) => {
        setRadioSelected(radio);
        const currentRangeValue = cloneDeep(rangeValues);
        updateRangeValues(currentRangeValue);
    };
    const updateRangeValues = (updatedRangeValues) => {
        setRangeValues(updatedRangeValues);
    };
    const updateValues = (selectedItem, key, indexKey) => {
        const currentRangeValue = cloneDeep(rangeValues);
        const index = isNilOrEmptyString(indexKey)
            ? 0
            : indexKey === "input1"
                ? 0
                : 1;
        if (!isNilOrEmptyString(currentRangeValue[radioSelected])) {
            currentRangeValue[radioSelected][index][key] = selectedItem;
        }
        updateRangeValues(currentRangeValue);
    };
    const onSelectChange = (e, key) => {
        if (radioSelected === "between") {
            updateValues(e.selectedItem, "selectedItemValue", key);
        }
        else {
            updateValues(e.selectedItem, "selectedItemValue");
        }
    };
    const onInputChange = (e, key) => {
        updateValues(e.target.value, "inputValue", key);
    };
    const onClearClick = () => {
        updateRangeValues({ ...defaultRangeValues });
        setRadioSelected(defaultValues || "");
    };
    const rangeOptions = (React.createElement("div", null,
        React.createElement("div", { className: "tw-w-10 tw-inline-block tw-mr-2" },
            React.createElement(Input, { "aria-label": "input1", onChange: (e) => onInputChange(e), value: rangeValues[radioSelected][0].inputValue })),
        React.createElement("div", { className: "tw-inline-block" },
            React.createElement(Select, { items: itemsForSelect, selectedItem: rangeValues[radioSelected][0].selectedItemValue, onChange: (e) => onSelectChange(e) }))));
    const betweenRangeOptions = (React.createElement("div", null,
        React.createElement("div", { className: "tw-w-10 tw-inline-block tw-mr-2" },
            React.createElement(Input, { "aria-label": "input1", onChange: (e) => onInputChange(e, "input1"), value: rangeValues[radioSelected][0].inputValue })),
        React.createElement("div", { className: "tw-inline-block" },
            React.createElement(Select, { items: itemsForSelect, selectedItem: rangeValues[radioSelected][0].selectedItemValue, onChange: (e) => onSelectChange(e, "input1") })),
        React.createElement("span", { className: "tw-text-xs tw-font-lato" }, " and "),
        React.createElement("div", { className: "tw-w-10 tw-inline-block tw-mr-2" },
            React.createElement(Input, { "aria-label": "input2", onChange: (e) => onInputChange(e, "input2"), value: (_a = rangeValues[radioSelected][1]) === null || _a === void 0 ? void 0 : _a.inputValue })),
        React.createElement("div", { className: "tw-inline-block" },
            React.createElement(Select, { items: itemsForSelect, selectedItem: (_b = rangeValues[radioSelected][1]) === null || _b === void 0 ? void 0 : _b.selectedItemValue, onChange: (e) => onSelectChange(e, "input2") }))));
    const items = [
        {
            children: intl.formatMessage({ id: "D6Uioh", defaultMessage: [{ type: 0, value: "Greater than" }] }),
            value: "greater_than",
            rangeOptions: rangeOptions,
        },
        {
            children: intl.formatMessage({ id: "0vVn8T", defaultMessage: [{ type: 0, value: "Less than" }] }),
            value: "less_than",
            rangeOptions: rangeOptions,
        },
        {
            children: intl.formatMessage({ id: "KXVB9u", defaultMessage: [{ type: 0, value: "Between" }] }),
            value: "between",
            rangeOptions: betweenRangeOptions,
        },
    ];
    return (React.createElement("div", null,
        React.createElement(RangeFilterOptions, { ...props, items: items, radioSelected: radioSelected, updateRadioSelected: updateRadioSelected, rangeValues: rangeValues, onClearClick: onClearClick })));
}

export { RangeFilter };
//# sourceMappingURL=RangeFilter.esm.js.map
